import * as React from 'react';

const InfoIcon = () => (
  <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1">
    <title>Info</title>
    <desc>Info icon</desc>
    <defs />
    <g id="2.0" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-490.000000, -976.000000)">
      <g id="changes-to-income" transform="translate(208.000000, 953.000000)" fill="#055a60" fillRule="nonzero">
        <g id="ic_info_outline_black_24px" transform="translate(282.000000, 23.000000)">
          <path d="M9.94230769,16.2884615 L12.0576923,16.2884615 L12.0576923,9.94230769 L9.94230769,9.94230769 L9.94230769,16.2884615 Z M11,0.423076923 C5.16153846,0.423076923 0.423076923,5.16153846 0.423076923,11 C0.423076923,16.8384615 5.16153846,21.5769231 11,21.5769231 C16.8384615,21.5769231 21.5769231,16.8384615 21.5769231,11 C21.5769231,5.16153846 16.8384615,0.423076923 11,0.423076923 Z M11,19.4615385 C6.33557692,19.4615385 2.53846154,15.6644231 2.53846154,11 C2.53846154,6.33557692 6.33557692,2.53846154 11,2.53846154 C15.6644231,2.53846154 19.4615385,6.33557692 19.4615385,11 C19.4615385,15.6644231 15.6644231,19.4615385 11,19.4615385 Z M9.94230769,7.82692308 L12.0576923,7.82692308 L12.0576923,5.71153846 L9.94230769,5.71153846 L9.94230769,7.82692308 Z" id="Shape" />
        </g>
      </g>
    </g>
  </svg>
);

export default InfoIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/InfoIcon/InfoIcon.tsx